import React from 'react';
import {Table} from '@/web-components';
import Util from '../../../../shared/util/util';
import {getQueryRenderer} from '../TimeRegistrationReportPageUtil';
import {getCurrencyCell, getGroupedRowColumns} from '../TimeRegistrationReportTableUtil';
import {GLOBAL_FILTER_FIELD, GLOBAL_FILTER_OPERATOR} from '../../../../../constants';

export const getPhaseRow = (
	data,
	intl,
	groupIndex,
	searchQuery,
	groupings,
	enabledColumns,
	hasNextPage,
	fetchMore,
	nextLevelProps,
	currency,
	reportId,
	sharedId,
	customFieldDefinitions,
	customFieldKeys
) => {
	const getColumns = phase =>
		getGroupedRowColumns(
			{
				label: <span>{phase.noPhase ? intl.formatMessage({id: 'time_reg_report.no_phase'}) : phase.name}</span>,
				actualHours: Util.convertMinutesToFullHour(phase.timeRegTotals?.totalTimeRegistered, intl, true),
				billableHours: Util.convertMinutesToFullHour(phase.timeRegTotals?.totalBillableRegistered, intl, true),
				nonBillableHours: Util.convertMinutesToFullHour(phase.timeRegTotals?.totalNonBillableRegistered, intl, true),
				actualBillableValueOfService: getCurrencyCell(phase.timeRegTotals?.totalPrice, currency, intl),
				actualCost: getCurrencyCell(phase.timeRegTotals?.totalCost, currency, intl),
			},
			customFieldDefinitions
		);

	return (
		<Table.Rows data={data} canExpand={true} loadMore={hasNextPage && fetchMore} {...nextLevelProps}>
			{({rowData, tableColumnsProps, nextLevelProps, expanded}) => {
				const filterField =
					rowData.noPhase === true ? GLOBAL_FILTER_FIELD.NON_PHASE_TIME_REG : GLOBAL_FILTER_FIELD.PHASE_TIME_REG;
				return (
					<>
						<Table.Row {...tableColumnsProps}>{getColumns(rowData)}</Table.Row>
						{expanded &&
							getQueryRenderer(
								null,
								groupings,
								searchQuery,
								groupIndex,
								enabledColumns,
								{field: filterField, operator: GLOBAL_FILTER_OPERATOR.IS, value: [rowData.phaseId]},
								nextLevelProps,
								currency,
								reportId,
								sharedId,
								customFieldDefinitions,
								customFieldKeys
							)}
					</>
				);
			}}
		</Table.Rows>
	);
};
